import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/partenaireskata`;

const getRequestConfig = () => {
  const token = localStorage.getItem("token");

  return {
    headers: token
      ? {
          Authorization: `Bearer ${token}`,
        }
      : {},
  };
};

const getErrorMessage = (error) => {
  const responseData = error?.response?.data;

  if (Array.isArray(responseData?.errors)) {
    return responseData.errors.join(" ");
  }

  return (
    responseData?.message ||
    error?.message ||
    "Une erreur inattendue est survenue."
  );
};

const handleApiError = (error) => {
  throw new Error(getErrorMessage(error));
};

export const getPartenairesKata = async (params = {}) => {
  try {
    const response = await axios.get(apiUrl, {
      ...getRequestConfig(),
      params,
    });

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getPartenairesKataStats = async () => {
  try {
    const response = await axios.get(
      `${apiUrl}/stats`,
      getRequestConfig()
    );

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getPartenaireKataById = async (id) => {
  try {
    const response = await axios.get(
      `${apiUrl}/${id}`,
      getRequestConfig()
    );

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const createPartenaireKata = async (data) => {
  try {
    const response = await axios.post(
      apiUrl,
      data,
      getRequestConfig()
    );

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const findOwnedPartenairesKata = async (
  credentials
) => {
  try {
    const response = await axios.post(
      `${apiUrl}/manage/lookup`,
      {
        credentials,
      },
      getRequestConfig()
    );

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const verifyPartenaireKata = async (
  id,
  credentials
) => {
  try {
    const response = await axios.post(
      `${apiUrl}/${id}/verify`,
      {
        credentials,
      },
      getRequestConfig()
    );

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updatePartenaireKata = async (
  id,
  credentials,
  data
) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/${id}`,
      {
        credentials,
        data,
      },
      getRequestConfig()
    );

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const managePartenaireKataLifecycle = async (
  id,
  credentials,
  action
) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/${id}/lifecycle`,
      {
        credentials,
        action,
      },
      getRequestConfig()
    );

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deletePartenaireKata = async (
  id,
  credentials
) => {
  try {
    const response = await axios.delete(`${apiUrl}/${id}`, {
      ...getRequestConfig(),
      data: {
        credentials,
      },
    });

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};